/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageInfoDto } from '../../models/page-info-dto';
import { ShopOrderDto } from '../../models/shop-order-dto';

export interface ShopOrderControllerSearch$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 주문 상태 필터
 */
  status?: 'READY' | 'PAID' | 'SHIPPING_PENDING' | 'DELIVERED' | 'CANCELLED';

/**
 * 조회 시작일 (YYYY-MM-DD)
 */
  dateFrom?: string;

/**
 * 상품 ID 필터
 */
  productId?: string;

/**
 * 조회 종료일 (YYYY-MM-DD)
 */
  dateTo?: string;

/**
 * 회원 ID 필터 (관리자용)
 */
  userId?: string;
}

export function shopOrderControllerSearch(http: HttpClient, rootUrl: string, params: ShopOrderControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
}>> {
  const rb = new RequestBuilder(rootUrl, shopOrderControllerSearch.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('status', params.status, {});
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('productId', params.productId, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items': Array<ShopOrderDto>;
      'pageInfo': PageInfoDto;
      }>;
    })
  );
}

shopOrderControllerSearch.PATH = '/api/shop-orders';
